import { render, staticRenderFns } from "./scoreBars.vue?vue&type=template&id=1f8022bc"
import script from "./scoreBars.vue?vue&type=script&lang=js"
export * from "./scoreBars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports